export default __webpack_public_path__ + "static/media/poster6.21ec459c.jpg";